// components/FAQManagement/FaqTable.jsx
import React from 'react';
import { toPersianNumbers } from '../../utils/toPersianNumbers';

const FaqTable = ({ faqs, loading, onEdit, onDelete }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-3/4 mb-4"></div>
          <div className="space-y-3">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="h-4 bg-gray-200 rounded"></div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-[#1E3A5F] text-[#FFC107]">
            <tr>
              <th className="px-6 py-3 text-right text-xs font-medium text-[#FFC107] uppercase tracking-wider w-20">
                ترتیب
              </th>
              <th className="px-6 py-3 text-right text-xs font-medium text-[#FFC107] uppercase tracking-wider w-1/4">
                پرسش
              </th>
              <th className="px-6 py-3 text-right text-xs font-medium text-[#FFC107] uppercase tracking-wider">
                پاسخ
              </th>
              <th className="px-6 py-3 text-right text-xs font-medium text-[#FFC107] uppercase tracking-wider w-28">
                وضعیت نمایش
              </th>
              <th className="px-6 py-3 text-right text-xs font-medium text-[#FFC107] uppercase tracking-wider w-24">
                عملیات
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {faqs.map((faq) => (
              <tr key={faq.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-semibold">
                  {toPersianNumbers(faq.order ?? 0)}
                </td>
                <td className="px-6 py-4">
                  <div className="text-sm font-semibold text-gray-900 line-clamp-2">
                    {faq.question}
                  </div>
                </td>
                <td className="px-6 py-4">
                  <div className="text-sm text-gray-600 max-w-lg truncate" title={faq.answer}>
                    {faq.answer}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {faq.is_active ? (
                    <span className="px-2.5 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                      فعال
                    </span>
                  ) : (
                    <span className="px-2.5 py-1 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">
                      غیرفعال
                    </span>
                  )}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => onEdit(faq)}
                      className="text-[#2196F3] hover:text-[#0C7CD5] p-1 rounded transition-colors"
                      title="ویرایش"
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                    </button>
                    <button
                      onClick={() => onDelete(faq)}
                      className="text-[#E53935] hover:text-[#CB1E1A] p-1 rounded transition-colors"
                      title="حذف"
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {faqs.length === 0 && (
        <div className="text-center py-12">
          <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <h3 className="mt-2 text-sm font-medium text-gray-900">سوالی یافت نشد</h3>
          <p className="mt-1 text-sm text-gray-500">با ثبت اولین پرسش متداول کار را آغاز کنید.</p>
        </div>
      )}
    </div>
  );
};

export default FaqTable;
